import getSymbolFromCurrency from 'currency-symbol-map';
import * as React from 'react';
import { useState, useEffect } from 'react';
import noImage from 'src/assets/images/noimage.png'
import ProductLegends from 'src/pages/ProductListing/ProductLegends';
import Helper from 'src/support/Helper';
import FactoryLeadTimeDisplay from 'src/component/Product/FactoryLeadTimeDisplay';

let cartProductData = JSON.parse(localStorage.getItem('cartProductData'))
let cartProductInventoryData = JSON.parse(localStorage.getItem('cartProductInventoryData'))

const CheckoutOrderItemList = (props) => {
    const { itemList, isQuote } = props; //14990 // 15033_main_orig

    const getAvailableQuantity = (v) => {
        if (v && v?.scheduleDetails?.length) {
            let sum = 0;
            v.scheduleDetails.forEach(ele => {
                sum += ele.quantity;
            });

            let avlQty = v.quantity - sum;
            return avlQty
        }
    }

    useEffect(() => {
        if (itemList?.length > 0) {
            localStorage.removeItem('cartProductData');
            localStorage.removeItem('cartProductInventoryData');
        }
    }, [itemList]);

    return (
        <>
            <div className="accordion accordion-with-arrow mycart-accordion mb-3 mt-3" id="mycart-accordion">
                <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <button id="collapseTwo" className="accordion-button font-16" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">Order Details</button>
                    </h2>
                    <div id="collapseOne" className="accordion-collapse collapse in" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                            <div className="table-responsive">
                                <table className="mycart-table" width="100%">
                                    <tbody>
                                        {itemList?.length > 0 &&
                                            itemList.map((v, i) => (
                                                <tr key={i}>
                                                    <td className="acc-product-img">
                                                        <div className="product-info nopadding">
                                                            <span className='checkout-item-count'>Item: {i + 1}</span>
                                                            <div className="product-img sect-1 text-center">
                                                                <img src={v.assetURL ? v.assetURL : noImage} />
                                                            </div>
                                                        </div>
                                                        <div className="prod-option-icon sect-2">
                                                            <div className="d-flex justify-content-start">
                                                                {/* {isQuote ? <ProductLegends single_product={v.product}
                                                                    onlyIcon={true} /> : */}
                                                                <ProductLegends single_product={cartProductData[v.itemNumber]}
                                                                    onlyIcon={true}
                                                                />
                                                                {/* } */}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-name">
                                                        <>
                                                            <strong>{v.erpMfrPartNumber}</strong> <br />
                                                            {v.manufacturerName !== undefined &&
                                                                <div>
                                                                    <span> by </span>
                                                                    {v.manufacturerName ? v.manufacturerName : ''}
                                                                </div>
                                                            }
                                                            <strong>{v.cpnTypeName === 'CPN' ? v.cpn : (v.manualCPN === '*' ? '' : v.manualCPN)}</strong>

                                                        </>
                                                    </td>
                                                    <td className="acc-product-info">
                                                        <div className={v.backOrderedQuantity > 0 ? "bs5 row" : "bs5 row d-none"}>
                                                            <div className="col-8">Backordered:</div>
                                                            <div className="col-4 text-end">{v.backOrderedQuantity}</div>
                                                        </div>
                                                        <div className="bs5 row">
                                                            {/* {isQuote ?
                                                                <FactoryLeadTimeDisplay
                                                                    single_product={v.product}
                                                                    single_product_inventory={v.product.assets.inventory}
                                                                    isAdditionalLead={true} /> : */}
                                                                <FactoryLeadTimeDisplay
                                                                    single_product={cartProductData[v.itemNumber]}
                                                                    single_product_inventory={cartProductInventoryData[v.partNumber]}
                                                                    isAdditionalLead={true} />
                                                            {/* }
                                                            {console.log(v.product)} */}
                                                        </div>
                                                        <div className="mb-3">
                                                            {v?.scheduleDetails?.length > 0 &&
                                                                <>
                                                                    <span className="">Scheduled Dates:</span>
                                                                    <div className="sceduledate-list border-bottom1 mb-1">
                                                                        <div className="d-flex  border-bottom1 justify-content-between">
                                                                            <div className="col-4 ps-0">Quantity</div>
                                                                            <div className="col-8 pe-0 text-end">Ship Date</div>
                                                                        </div>
                                                                        {getAvailableQuantity(v) > 0 ?
                                                                            <div className="bs5 row m-0">
                                                                                <div className="col-4 ps-0">{getAvailableQuantity(v)}</div>
                                                                                <div className="col-8 pe-0 text-end">
                                                                                    As Available
                                                                                </div>
                                                                            </div> : null}
                                                                        {v.scheduleDetails.map((p, j) => (
                                                                            <div className="bs5 row m-0" key={j}>
                                                                                <div className="col-4 ps-0">{p.quantity}</div>
                                                                                <div className="col-8 pe-0 text-end">
                                                                                    {Helper.dateFormatFromString(p.scheduledDate, true)}
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td className="acc-product-total">
                                                        <div className="bs5 row">
                                                            <div className="col-4">Unit Price:</div>
                                                            <div className="col-8 text-end text-right">{Helper.getFormatNumber(Number(v.unitPrice), v.currency, getSymbolFromCurrency(v.currency), 5)}</div>
                                                        </div>
                                                        <div className="bs5 row">
                                                            <div className="col-4">Subtotal:</div>
                                                            <div className="col-8 text-end">{Helper.getFormatNumber(Number(v.subtotal), v.currency, getSymbolFromCurrency(v.currency))}
                                                            </div>
                                                        </div>
                                                        <div className="bs5 row">
                                                            <div className="col-4">Quantity:</div>
                                                            <div className="col-8 text-end text-right">{v.quantity}</div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default CheckoutOrderItemList;